import {Link, useNavigate} from "react-router-dom";
import {useForm} from "react-hook-form";
import {useEffect, useRef, useState} from 'react';
import { toast } from 'react-toastify';
import axios from "axios";
import {loginURL} from "../../../Library/URLs";
import {generateTransactionID} from "../../../Library/Utilities";
import {SessionManagement} from "../../../Library/SessionManagement";
import { useDispatch } from "react-redux";
import { LocalShipmentActions } from "../../../store/Local_Slice";

const FormSection = () => {
    const {register, reset, handleSubmit, formState: {errors}} = useForm();
    const [isClear, setisClear] = useState(false);
    const dispatch=useDispatch()

    const [isError, setErrorVisibility] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    const [isSubmitting, setIsSubmitting] = useState(false);
    const navigate = useNavigate();
    const form = useRef(null);

    function getDevice() {
        let operatingSystem = 'Not known';
        if (window.navigator.appVersion.indexOf('Win') !== -1) { operatingSystem = 'Windows OS'; }
        if (window.navigator.appVersion.indexOf('Mac') !== -1) { operatingSystem = 'MacOS'; }
        if (window.navigator.appVersion.indexOf('X11') !== -1) { operatingSystem = 'UNIX OS'; }
        if (window.navigator.appVersion.indexOf('Linux') !== -1) { operatingSystem = 'Linux OS'; }

        let currentBrowser = 'Not known';
        if (window.navigator.userAgent.indexOf('Chrome') !== -1) { currentBrowser = 'Chrome'; }
        else if (window.navigator.userAgent.indexOf('Firefox') !== -1) { currentBrowser = 'Mozilla Firefox'; }
        else if (window.navigator.userAgent.indexOf('MSIE') !== -1) { currentBrowser = 'Internet Exployer'; }
        else if (window.navigator.userAgent.indexOf('Edge') !== -1) { currentBrowser = 'Edge'; }
        else if (window.navigator.userAgent.indexOf('Safari') !== -1) { currentBrowser = 'Safari'; }
        else if (window.navigator.userAgent.indexOf('Opera') !== -1) { currentBrowser = 'Opera'; }
        else if (window.navigator.userAgent.indexOf('Opera') !== -1) { currentBrowser = 'YaBrowser'; }

        return currentBrowser + " on " + operatingSystem;
    }


    useEffect(()=>{
        dispatch(LocalShipmentActions.GetAuth(false))
    },[])


    const loginUser = (e) => {
        console.log("hello..");
        e.preventDefault();

        const data = new FormData(form.current);

        const formValues = {};

        for (let [key, value] of data.entries()) {
            formValues[key] = value;
        }
        formValues["device_id"] = "value";
        formValues["device_name"] = getDevice();
        formValues["token"] = "value";
        formValues["company_id"] = "44";
        formValues["transaction_id"] = generateTransactionID(15);

        console.log(formValues);

        setIsSubmitting(true);

        axios
            .post(loginURL, formValues)
            .then(function (response) {
                console.log('login res',response);
                setIsSubmitting(false);

                if (response["data"]["success"] === false) {
                    setErrorMessage(response["data"]["message"]);
                    setErrorVisibility(true);
                    toast.error(response["data"]["message"])
                    setTimeout(() => {
                        setErrorVisibility(false);
                    }, 5000);
                } else if (response["data"]["success"] === true) {
                    const name = response["data"]["data"]["fullname"];
                    const email = response["data"]["data"]["email"];
                    const phone = response["data"]["data"]["phone"];
                    const profileImageURL = response["data"]["data"]["profile_image_url"];
                    const userID = response["data"]["data"]["user_id"];
                    const companyID = response["data"]["data"]["company_id"];
                    const sessionID = response["data"]["data"]["user_ses_id"];
                    // console.log('login res'+response)
                    SessionManagement.setName(name);
                    SessionManagement.setEmail(email);
                    SessionManagement.setPhone(phone);
                    SessionManagement.setProfileImageURL(profileImageURL);
                    SessionManagement.setUserID(userID);
                    SessionManagement.setCompanyID(companyID)
                    SessionManagement.setSessionID(sessionID);
                    SessionManagement.setAuthenticationStatus("yes");
                    dispatch(LocalShipmentActions.GetAuth(true))
                    navigate('/dashboard', {replace: true});
                    toast.success(response["data"]["message"])
                }
            })
            .catch(function (error) {
                return error;
            });
    };

    return (
        <div className="Login_Form">
            <h3>Let's get started</h3>
            <p>To continue, please provide a valid login details.</p>
            <form  ref={form} onSubmit={loginUser}>
                <div className="Box">
                    <input placeholder="Enter email or phone number" name="phone"
                           className={`${errors.country ? 'error' : 'noError'}`} />
                    {errors.country &&
                        <span className={`${errors.country ? 'errorText' : ''}`}>Country field is required</span>}
                </div>
                <div className="Box">
                    <input placeholder="Enter password" name="password" type="password"
                           className={`${errors.phone_number ? 'error' : 'noError'}`} />
                    {errors.phone_number && <span className={`${errors.phone_number ? 'errorText' : ''}`}>Phone Number field is required</span>}
                </div>

                <Link className="Forgot_Text" to="/reset">Forgot Pasword?</Link>

                <div className="Terms">
                    By completing this transaction, you represent that you have read, understand and accept the
                    Zee Express <Link to="/login">terms of service</Link> and <Link to="/login">privacy policy</Link>.
                </div>

                <button type="submit" className="Btn">
                    {isSubmitting === false ? (
                        <span className="button-text">LOGIN</span>
                    ) : (
                        <span className="spinner-border spinner-grow-sm"/>
                    )}
                </button>
            </form>
        </div>
    );
}

export default FormSection;